import "./iconify_sheet.css";
import "./DataBySite.css";
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";
import electric from "../../images/power_system.png";
import inverter from "../../images/cabinet.png";
import solar from "../../images/solar.png";
import battery from "../../images/battery_animation.gif";
import load from "../../images/load.webp";
import mppt from "../../images/mppt.jpeg";
import rectifier from "../../images/rectifier.png";
import { callUnsetApi } from "../../utils/api.js"; // Import the global unset API function

const DataBySite = () => {
  const location = useLocation();
  const stateName = sessionStorage.getItem("selectedState");
  const siteId = sessionStorage.getItem("selectedSiteId");
  const [controllerDate, setControllerDate] = useState("");
  const [isOnline, setIsOnline] = useState(false);
  const [data, setData] = useState({});
  const [statusClass, setStatusClass] = useState("offline");
  const [dateTime, setDateTime] = useState(null);
  const [hupsdata, setHupsData] = useState(null);
  const [frameData, setFrameData] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/get_data_by_site");
    }

    // Call the "set" API when the component mounts
    const callSetApi = async () => {
      try {
        const response = await fetch(
          `https://api.bharatnet.sunshineiotronics.com/api/v2/live_frame/set/${siteId}`,
          {
            method: "GET",
          }
        );
        const data = await response.json();
        console.log("Set API response:", data);
      } catch (error) {
        console.error("Error calling set API:", error);
      }
    };

    callSetApi();

    return () => {
      callUnsetApi(siteId);
    };
  }, [navigate, siteId]);
  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Typography key="4" sx={{ color: "text.primary" }}>
      Go Live
    </Typography>,
  ];

  const handleViewMore = (siteId) => {
    navigate("/view_more", {
      state: { stateName, siteId },
    });
  };
  // Helper function to update icon status
  const updateSpecificIconStatus = (
    elementId,
    condition,
    addClass,
    removeClass,
    text
  ) => {
    const element = document.getElementById(elementId);
    if (element) {
      if (condition) {
        element.classList.remove(removeClass);
        element.classList.add(addClass);
        element.innerText = text.connected;
      } else {
        element.classList.remove(addClass);
        element.classList.add(removeClass);
        element.innerText = text.disconnected;
      }
    } else {
      console.warn(`Element with ID ${elementId} not found`);
    }
  };
  // Helper function to update icon status
  const updateIconStatus = (elementId, condition, addClass, removeClass) => {
    const element = document.getElementById(elementId);
    if (condition) {
      element.classList.remove(removeClass);
      element.classList.add(addClass);
    } else {
      element.classList.remove(addClass);
      element.classList.add(removeClass);
    }
  };

  useEffect(() => {
    const fetchHupsData = async () => {
      const fetchUrlHups = `https://api.bharatnet.sunshineiotronics.com/api/v2/hups/${siteId}`;
      try {
        const response = await fetch(fetchUrlHups);
        const result = await response.json();
        setHupsData(result);
        updateSpecificIconStatus(
          "pdu_connected",
          parseInt(result.hups_connected_status, 10) === 1,
          "badge-success",
          "badge-danger",
          { connected: "Connected", disconnected: "Disconnected" }
        );
      } catch (error) {
        console.error("Error fetching hupsdata:", error);
      }
    };

    const fetchFrameData = async () => {
      const fetchUrlFrame = `https://api.bharatnet.sunshineiotronics.com/api/v2/regular_frame_by_site/${siteId}`;
      try {
        const response = await fetch(fetchUrlFrame);
        const responseData = await response.json();
        setFrameData(responseData);
        setControllerDate(responseData.controller_datetime);

        const currentDate = new Date();
        const siteDate = new Date(
          responseData.controller_datetime
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("-") +
            " " +
            responseData.controller_datetime.split(" ")[1]
        );

        setDateTime(responseData.controller_datetime);
        console.log(responseData.system_voltage);

        const diffSeconds = Math.floor((currentDate - siteDate) / 1000);
        console.log(`Time difference in seconds: ${diffSeconds}`);

        if (diffSeconds <= 300) {
          setIsOnline(true);
          setStatusClass("online");
        } else {
          setIsOnline(false);
          setStatusClass("offline");
        }

        // Update icon statuses based on responseData
        updateIconStatus(
          "smoke_icon",
          responseData.smoke_alarm === 1,
          "cbi--smoke-detector-red",
          "cbi--smoke-detector"
        );
        updateIconStatus(
          "door_open_icon",
          responseData.door_alarm === 1,
          "door--open--icon",
          "door--close--icon"
        );
        updateIconStatus(
          "water_logging_icon",
          responseData.water_logging_alarm === 1,
          "water--logging--on",
          "water--logging--off"
        );
        updateIconStatus(
          "water_leakage_icon",
          responseData.water_leakage_alarm === 1,
          "water--leakage--on",
          "water--leakage--off"
        );
        updateIconStatus(
          "unauthorised_access_icon",
          responseData.unauthorised_access === 1,
          "shield--off--icon",
          "shield--on--icon"
        );
        updateIconStatus(
          "hct_icon",
          responseData.htc_alarm === 1,
          "temperature-high--active--icon",
          "temperature-high--inactive--icon"
        );
        updateIconStatus(
          "inside_temp_icon",
          responseData.tcan_fail_alarm === 1,
          "temperature--inside--icon--red",
          "temperature--inside--icon"
        );
        updateIconStatus(
          "outside_temp_icon",
          responseData.tamb_fail_alarm === 1,
          "temperature--outside--icon--red",
          "temperature--outside--icon"
        );
        updateIconStatus(
          "humidity_icon_1",
          responseData.humidity_fail === 1,
          "humidity--icon--red",
          "humidity--icon"
        );
        updateSpecificIconStatus(
          "ftu_connected",
          parseInt(responseData.ftu_connected, 10) === 1,
          "badge-success",
          "badge-danger",
          { connected: "Connected", disconnected: "Disconnected" }
        );

        // Handle fan statuses
        for (let i = 1; i <= 6; i++) {
          const fanElement = document.getElementById(`fan_run_0${i}`);
          const fanStatus = responseData[`fan0${i}_status`];
          if (fanStatus === 2) {
            fanElement.classList.remove(
              "fan--default--icon",
              "fan--on--icon",
              "fan--fail--off-icon"
            );
            fanElement.classList.add("fan--fail--off-icon");
          } else if (fanStatus === 1) {
            fanElement.classList.remove(
              "fan--default--icon",
              "fan--on--icon",
              "fan--fail--off-icon"
            );
            fanElement.classList.add("fan--on--icon");
          } else {
            fanElement.classList.remove(
              "fan--default--icon",
              "fan--on--icon",
              "fan--fail--off-icon"
            );
            fanElement.classList.add("fan--default--icon");
          }
        }
      } catch (error) {
        console.error("Error fetching frame data:", error);
      }
    };

    const fetchData = async () => {
      await fetchHupsData();
      await fetchFrameData();
    };

    const fetchInitialData = async () => {
      setInitialLoading(true);
      await fetchData();
      setInitialLoading(false);
    };

    // Fetch initial data
    fetchInitialData();

    // Set interval to fetch data every 3 seconds
    const intervalId = setInterval(fetchData, 3000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [siteId, location]);

  if (initialLoading) {
    return <div>Loading...</div>;
  }

  const query_01 = hupsdata.query_01;
  const query_02 = hupsdata.query_02;
  const query_03 = hupsdata.query_03;
  const query_04 = hupsdata.query_04;
  const query_05 = hupsdata.query_05;
  const query_06 = hupsdata.query_06;

  function getBatteryPercentage(voltage) {
    const maxVoltage = 13.8;
    const minVoltage = 9;
    const criticalVoltage = 7;
    if (voltage >= maxVoltage) {
      return 100;
    } else if (voltage <= criticalVoltage) {
      return 0;
    } else if (voltage <= minVoltage) {
      return Math.round(
        ((voltage - criticalVoltage) / (minVoltage - criticalVoltage)) * 30
      );
    } else {
      return Math.round(
        ((voltage - minVoltage) / (maxVoltage - minVoltage)) * 70 + 30
      );
    }
  }

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack spacing={2}>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="medium" />}
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Stack>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                <div className={`status-indicator ${statusClass}`}>
                  <div className="status-light"></div>
                  <span className="status-text">
                    {siteId} | {dateTime}
                  </span>
                </div>
              </Typography>
            </Box>
            <br />
            <br />
            <Card className="my-1 mx-3">
              <CardContent>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h1>Cabinet Data</h1>
                </div>
                <h2>Measurements</h2>
                <br />

                <div className="d-flex justify-content-between p-3">
                  {/* Container for the 4 columns */}
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Inside Temperature */}
                    <div
                      className="p-3 text-center btn-wrapper"
                      style={{ flex: 1, borderRight: "1px groove black" }}
                    >
                      <span
                        className="temperature--inside--icon"
                        id="inside_temp_icon"
                      ></span>
                      <p className="fs-5 fw-medium">Inside Temperature</p>
                      <p className="fs-3 fw-bold inside-temp">
                        {frameData.temperature_inside} °C
                      </p>
                    </div>

                    {/* Outside Temperature */}
                    <div
                      className="p-3 text-center btn-wrapper"
                      style={{ flex: 1, borderRight: "1px groove black" }}
                    >
                      <span
                        className="temperature--outside--icon"
                        id="outside_temp_icon"
                      ></span>
                      <p className="fs-5 fw-medium">Outside Temperature</p>
                      <p className="fs-3 fw-bold outside-temp">
                        {frameData.temperature_outside} °C
                      </p>
                    </div>

                    {/* Humidity */}
                    <div
                      className="p-3 text-center btn-wrapper"
                      style={{ flex: 1, borderRight: "1px groove black" }}
                    >
                      <span
                        id="humidity_icon_1"
                        className="humidity--icon"
                      ></span>
                      <p className="fs-5 fw-medium" id="humidity_icon">
                        Humidity
                      </p>
                      <p className="fs-3 fw-bold humidity">
                        {frameData.humidity} %
                      </p>
                    </div>

                    {/* UPS Voltage */}
                    <div
                      className="p-3 text-center btn-wrapper"
                      style={{ flex: 1 }}
                    >
                      <span className="battery--icon"></span>
                      <p className="fs-5 fw-medium">Lock Battery</p>
                      <p className="fs-3 fw-bold outside-temp">
                        {getBatteryPercentage(frameData.system_voltage)}%
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
            <br />
            {/* Alarms Overview Section */}
            <Card className="my-1 mx-3">
              <CardContent>
                <h2>Alarms / Signals</h2>
                <br />
                <div className="d-flex justify-content-between p-3">
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Fan 01 */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{ flex: 1, borderRight: "1px solid #ddd" }}
                    >
                      <div>
                        <p
                          className="fs-5 fw-medium"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "400",
                          }}
                        >
                          Fan 01
                        </p>
                        <span
                          className="fan--default--icon"
                          id="fan_run_01"
                        ></span>
                        <p
                          className="fs-5 fw-bold fan_01_runtime"
                          id="frh1"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {frameData.fan_run_hour_01} hr
                        </p>
                      </div>
                    </div>

                    {/* Fan 02 */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{ flex: 1, borderRight: "1px solid #ddd" }}
                    >
                      <div>
                        <p
                          className="fs-5 fw-medium"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          Fan 02
                        </p>
                        <span
                          className="fan--default--icon"
                          id="fan_run_02"
                        ></span>

                        <p
                          className="fs-5 fw-bold fan_02_runtime"
                          id="frh2"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {frameData.fan_run_hour_02} hr
                        </p>
                      </div>
                    </div>

                    {/* Fan 03 */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{ flex: 1, borderRight: "1px solid #ddd" }}
                    >
                      <div>
                        <p
                          className="fs-5 fw-medium"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          Fan 03
                        </p>
                        <span
                          className="fan--default--icon"
                          id="fan_run_03"
                        ></span>

                        <p
                          className="fs-5 fw-bold fan_03_runtime"
                          id="frh3"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {frameData.fan_run_hour_03} hr
                        </p>
                      </div>
                    </div>

                    {/* Fan 04 */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{ flex: 1, borderRight: "1px solid #ddd" }}
                    >
                      <div>
                        <p
                          className="fs-5 fw-medium"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          Fan 04
                        </p>
                        <span
                          className="fan--default--icon"
                          id="fan_run_04"
                        ></span>

                        <p
                          className="fs-5 fw-bold fan_04_runtime"
                          id="frh4"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {frameData.fan_run_hour_04} hr
                        </p>
                      </div>
                    </div>

                    {/* Fan 05 */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{ flex: 1, borderRight: "1px solid #ddd" }}
                    >
                      <div>
                        <p
                          className="fs-5 fw-medium"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          Fan 05
                        </p>
                        <span
                          className="fan--default--icon"
                          id="fan_run_05"
                        ></span>

                        <p
                          className="fs-5 fw-bold fan_05_runtime"
                          id="frh5"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {frameData.fan_run_hour_05} hr
                        </p>
                      </div>
                    </div>

                    {/* Fan 06 */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{ flex: 1 }}
                    >
                      <div>
                        <p
                          className="fs-5 fw-medium"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          Fan 06
                        </p>
                        <span
                          className="fan--default--icon"
                          id="fan_run_06"
                        ></span>

                        <p
                          className="fs-5 fw-bold fan_06_runtime"
                          id="frh6"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {frameData.fan_run_hour_06} hr
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Second row */}
                <div className="d-flex justify-content-between p-3">
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: "2rem",
                    }}
                  >
                    {/* Smoke/Fire */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{
                        flex: 1,
                        borderRight: "1px solid #ddd",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <span
                        className="cbi--smoke-detector"
                        id="smoke_icon"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      ></span>
                      <p className="fs-5 fw-medium">Smoke/Fire</p>
                    </div>

                    {/* Door Open */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{
                        flex: 1,
                        borderRight: "1px solid #ddd",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <span
                        className="door--close--icon"
                        id="door_open_icon"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      ></span>
                      <p className="fs-5 fw-medium">Door Open</p>
                    </div>

                    {/* High-Cabinet Temperature */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{
                        flex: 1,
                        borderRight: "1px solid #ddd",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <span
                        className="temperature-high--inactive--icon"
                        id="hct_icon"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      ></span>
                      <p className="fs-5 fw-medium">High-Cabinet Temperature</p>
                    </div>

                    {/* Water Leakage */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{
                        flex: 1,
                        borderRight: "1px solid #ddd",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <span
                        className="water--leakage--off"
                        id="water_leakage_icon"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      ></span>
                      <p className="fs-5 fw-medium">Water Leakage</p>
                    </div>

                    {/* Water Logging */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{
                        flex: 1,
                        borderRight: "1px solid #ddd",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <span
                        className="water--logging--off"
                        id="water_logging_icon"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      ></span>
                      <p className="fs-5 fw-medium">Water Logging</p>
                    </div>

                    {/* Unauthorised Access */}
                    <div
                      className="text-center btn-wrapper p-2"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <span
                        className="shield--on--icon"
                        id="unauthorised_access_icon"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      ></span>
                      <p className="fs-5 fw-medium">Unauthorised Access</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
            <br />
            {/* End Alarms Overview Section */}

            <br />
            {/* End Fan Run Hours Section */}
            <Card>
              <CardContent>
                {/* Title */}
                <div className="card-title-container">
                  <h1>Hybrid UPS</h1>
                </div>
                <br />

                <div className="diagram-container">
                  {/* Electric Tower */}
                  <div className="vertical-group-start">
                    <div className="vertical-group">
                      <Card
                        sx={{
                          width: "13rem",
                          height: "14rem",
                          border: "2px solid #ccc",
                        }}
                      >
                        <CardContent>
                          <div className="block electric-tower">
                            <img className="image-data" src={electric} />
                            <div className="fields">
                              <div
                                className="field"
                                style={{ textAlign: "center" }}
                              >
                                Mains
                              </div>
                              <div className="field">Mains Fail: No</div>
                              <div className="field">
                                Mains Run Hrs:{" "}
                                {hupsdata.ac_mains_run_hours} hrs
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>

                      {/* Arrow from Electric Tower to Rectifier */}
                      <div className="horizontal-connection">
                        <div class="arrow1">
                          <span>&gt;</span>
                          <span>&gt;</span>
                          <span>&gt;</span>
                          <span>&gt;</span>
                        </div>
                        <Card
                          sx={{
                            width: "22rem",
                            height: "16rem",
                            border: "2px solid #ccc",
                          }}
                        >
                          <CardContent>
                            <div className="block rectifier">
                              <img
                                src={rectifier}
                                className="image-data"
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  marginTop: "20px",
                                }}
                              />
                              <div
                                className="fields"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {/* Rectifier 1 */}
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: "center",
                                    paddingRight: "10px",
                                  }}
                                >
                                  <div
                                    className="field"
                                    style={{
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Rectifier 
                                  </div>
                                  {/* <div
                                    className="field"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    O/P Voltage:{" "}
                                    {
                                      hupsdata.rectifier_output_voltage_1
                                    }
                                    V
                                  </div> */}
                                  <div
                                    className="field"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    O/P Current:{" "}
                                    {
                                      hupsdata.rectifier_output_current
                                    }
                                    A
                                  </div>
                                </div>

                                {/* Vertical Line */}
                                {/* <div
                                  style={{
                                    width: "2px",
                                    backgroundColor: "#ccc",
                                    height: "60px",
                                    margin: "0 10px",
                                  }}
                                ></div> */}

                                {/* Rectifier 2
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: "center",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  <div
                                    className="field"
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Rectifier 2
                                  </div>
                                  <div
                                    className="field"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    O/P Voltage:{" "}
                                    {
                                      hupsdata.rectifier_output_voltage_2
                                    }
                                    V
                                  </div>
                                  <div
                                    className="field"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    O/P Current:{" "}
                                    {
                                      hupsdata.rectifier_output_current_2
                                    }
                                    A
                                  </div>
                                </div> */}
                              </div>

                              {/* Output Power (Centered Below the Line) */}
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                Output Power:{" "}
                                {hupsdata.rectifier_output_power}KW
                              </div>
                            </div>
                          </CardContent>
                        </Card>

                        <div className="horizontal-connection">
                          <div class="arrow1" style={{ marginTop: "10rem" }}>
                            <span>&gt;</span>
                            <span>&gt;</span>
                            <span>&gt;</span>
                            <span>&gt;</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Solar Panel Section */}

                    <div className="vertical-connection">
                      <div className="arrow-down">
                        <span>&gt;</span>
                        <span>&gt;</span>
                      </div>
                    </div>
                    <div className="vertical-group">
                      {/* Solar Panel */}

                      {/* Arrow from Solar Panel to MPPT */}
                      <div className="horizontal-connection">
                        <Card
                          sx={{
                            width: "22rem",
                            height: "17rem",
                            marginLeft: "20rem",
                            border: "2px solid #ccc",
                          }}
                        >
                          <CardContent>
                            <div className="battery-section-1">
                              <div className="block battery">
                                <img
                                  src={battery}
                                  className="image-data"
                                  style={{ width: "65px" }}
                                />
                                <div
                                  className="fields"
                                  style={{ marginTop: "2em" }}
                                >
                                  <div
                                    className="field"
                                    style={{ textAlign: "center" }}
                                  >
                                    Battery
                                  </div>
                                  <div className="field">
                                    Voltage: {hupsdata.battery_voltage}
                                    V
                                  </div>
                                  <div className="field">
                                    Current:{" "}
                                    {hupsdata.battery_current.toFixed(
                                      1
                                    )}
                                    A
                                  </div>
                                  {/* <div className="field">
                                    SOC: {hupsdata.soc_module_1}%
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                        <div className="horizontal-connection">
                          <div class="arrow1">
                            <span>&gt;</span>
                            <span>&gt;</span>
                            <span>&gt;</span>
                            <span>&gt;</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="vertical-connection">
                      <div className="arrow-up">
                        <span>&gt;</span>
                        <span>&gt;</span>
                      </div>
                    </div>

                    <div className="vertical-group">
                      {/* Solar Panel */}
                      <Card
                        sx={{
                          width: "13rem",
                          height: "14rem",
                          border: "2px solid #ccc",
                        }}
                      >
                        <CardContent>
                          <div className="block solar-panel">
                            <img src={solar} className="image-data" />
                            <div className="fields">
                              <div
                                className="field"
                                style={{ textAlign: "center" }}
                              >
                                Solar Panel
                              </div>
                              <div className="field">
                                Ultimate Capacity:{" "}
                                {hupsdata.solar_ultimate_capacity}Wp
                              </div>
                              <div className="field">
                                Solar Current: {hupsdata.solar_current}
                                A
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>

                      {/* Arrow from Solar Panel to MPPT */}
                      <div className="horizontal-connection">
                        <div class="arrow1">
                          <span>&gt;</span>
                          <span>&gt;</span>
                          <span>&gt;</span>
                          <span>&gt;</span>
                        </div>
                        <Card
                          sx={{
                            width: "22rem",
                            height: "14rem",
                            border: "2px solid #ccc",
                          }}
                        >
                          <CardContent>
                            <div className="block mppt">
                              <img src={mppt} className="image-data" />
                              <div className="fields">
                                <div
                                  className="field"
                                  style={{ textAlign: "center" }}
                                >
                                  MPPT
                                </div>
                                <div className="field">
                                  Output Voltage:{" "}
                                  {hupsdata.mppt1_output_voltage}V
                                </div>
                                <div className="field">
                                  Output Current:{" "}
                                  {hupsdata.mppt1_output_current}A
                                </div>
                                <div className="field">
                                  Output Power:{" "}
                                  {hupsdata.mppt1_output_power}W
                                </div>
                              </div>
                            </div>
                          </CardContent>
                        </Card>

                        <div className="horizontal-connection">
                          <div class="arrow1" style={{ marginBottom: "10rem" }}>
                            <span>&gt;</span>
                            <span>&gt;</span>
                            <span>&gt;</span>
                            <span>&gt;</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />

                  {/* battery and inverter */}

                  <div className="battery-section-imp">
                    <div className="merge-battery-inverter">
                      {/* <Card sx={{ width: "13rem", height: "19rem" }}>
                        <CardContent>
                          <div className="battery-section-1">
                            <div className="block battery">
                              <img
                                src={battery}
                                className="image-data"
                                style={{ width: "65px" }}
                              />
                              <div
                                className="fields"
                                style={{ marginTop: "2em" }}
                              >
                                <div
                                  className="field"
                                  style={{ textAlign: "center" }}
                                >
                                  Battery
                                </div>
                                <div className="field">
                                  Voltage: {hupsdata.query_01.battery_voltage}V
                                </div>
                                <div className="field">
                                  Current:{" "}
                                  {hupsdata.query_01.battery_current.toFixed(1)}
                                  A
                                </div>
                                <div className="field">
                                  SOC: {hupsdata.query_05.soc_module_1}%
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card> */}

                      <Card
                        sx={{
                          width: "15rem",
                          height: "45rem",
                          marginTop: "2rem",
                          border: "2px solid #ccc",
                          borderRadius: "40px",
                        }}
                      >
                        <CardContent>
                          <div
                            className="battery-section-1"
                            style={{ marginTop: "15rem" }}
                          >
                            <div className="block battery">
                              <img src={load} className="image-data" />
                              <div className="fields">
                               <div
                                  className="field"
                                  style={{ textAlign: "center" }}
                                >
                                  Load
                                </div>
                                <div className="field">
                                  Load Current:{" "}
                                  {hupsdata.load_current}A
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                                         </div>
                  </div>
                </div>
                <div className="button-div-view">
                  <Button
                    color="success"
                    onClick={handleViewMore}
                    sx={{
                      border: "1px solid #997d3d",
                      color: "#997d3d",
                      width: "10rem",
                    }}
                  >
                    View More
                  </Button>
                </div>
              </CardContent>
            </Card>

            <br />
            <Card>
              <CardContent>
                <h4 className="card-title">RS485</h4>
                <div className="row my-3">
                  <div className="col-md-12">
                    <table className="table table-bordered">
                      <thead className="table-grey">
                        <tr>
                          <th className="fs-6">Device</th>
                          <th className="fs-6">ID</th>
                          <th className="fs-6">Baud Rate</th>
                          <th className="fs-6">Polling Success Rate</th>
                          <th className="fs-6">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Device 01 */}
                        <tr>
                          <td>Fan and Lock Controller</td>
                          <td>01</td>
                          <td>9600</td>
                          <td>90%</td>
                          <td>
                            <p className="fs-6">
                              <span
                                className="badge-danger py-2 px-2"
                                id="ftu_connected"
                              ></span>
                            </p>
                          </td>
                        </tr>
                        {/* Device 02 */}
                        <tr>
                          <td>Hybrid UPS</td>
                          <td>02</td>
                          <td>9600</td>
                          <td>80%</td>
                          <td>
                            <p className="fs-6">
                              <span
                                className="badge-danger py-2 px-2"
                                id="pdu_connected"
                              ></span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </CardContent>
            </Card>
            <br />
            <Card
              sx={{
                borderRadius: "15px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                background: "linear-gradient(135deg, #ffffff, #f8f9fc)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "1rem",
              }}
            >
              <CardContent sx={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "2rem",
                    width: "100%",
                  }}
                >
                  {/* Hardware Version */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      flex: 1,
                      textAlign: "end",
                      flexDirection: "column",
                      padding: "1rem",
                      borderRadius: "10px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      minWidth: "15rem", // Ensure the box is wide enough
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        whiteSpace: "nowrap",
                        color: "grey",
                      }}
                    >
                      {" "}
                      Software Checksum - 03727CCB | Hardware Version -{" "}
                      {frameData.gateway_hardware_version} | Software Version -{" "}
                      {frameData.gateway_software_version}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>

            <br />
          </div>
        </div>
      </div>
    </Box>
  );
};

export default DataBySite;
